module.exports = __webpack_public_path__ + "static/media/power.6b0d25e3.svg";